export default __webpack_public_path__ + "static/media/arrow-up.5f956e11.svg";